<template>
  <div class="cta-sectionnaka">
    <p class="cta-sectionnaka-text">
      <span class="bold-text">{{ text }}</span
      ><br />{{ subText }}
    </p>
    <v-container>
      <v-btn @click="handleClick" class="cta-button" block large>
        {{ buttonText }}
      </v-btn>
    </v-container>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";

const router = useRouter();

const props = defineProps({
  text: {
    type: String,
    default: "「自分の活動でもクラファンをやってみたい」",
  },
  subText: {
    type: String,
    default: "と思った方は、配信クラファンについて詳しくご覧ください👇",
  },
  buttonText: {
    type: String,
    default: "配信クラファンの詳細を見る",
  },
  route: {
    type: String,
    default: "/crowdfundinginvite",
  },
  articleId: {
    type: String,
    default: "",
  },
});

function handleClick() {
  const hasArticleId = !!props.articleId;

  // Google AnalyticsでCTAクリックを計測（gtagが存在する場合のみ）
  // 注意: このプロジェクトではGTMを使用しているため、通常はwindow.gtagは初期化されていませんが、
  //       GTMの設定によってはgtagが利用可能になる場合もあります
  const gtagExists = typeof window.gtag === "function";

  if (gtagExists && hasArticleId) {
    try {
      const gtagParams = {
        event_category: "Article CTA",
        event_label: props.articleId,
        article_id: props.articleId,
        button_text: props.buttonText,
        destination_path: props.route,
      };

      window.gtag("event", "cta_click", gtagParams);

      // デバッグ用ログ（開発環境のみ）
      if (process.env.NODE_ENV === "development") {
        console.log("✅ gtag event sent:", {
          event: "cta_click",
          ...gtagParams,
        });
      }
    } catch (error) {
      console.error("❌ Failed to send gtag event:", error);
    }
  }

  // dataLayer経由で送信（GTM経由でGoogle Analyticsに送信される）
  // このプロジェクトではGTMを使用しているため、こちらが主要な送信方法です
  //
  // 【重要】GTMでの設定が必要です：
  // 1. トリガー: イベント名が「cta_click」の場合に発火
  // 2. タグ: Google Analytics: GA4 Event を設定
  // 3. 変数（カスタムディメンションとして使用する場合）:
  //    - article_id (DataLayer変数: article_id)
  //    - button_text (DataLayer変数: button_text)
  //    - destination_path (DataLayer変数: destination_path)
  if (window.dataLayer && Array.isArray(window.dataLayer)) {
    try {
      window.dataLayer.push({
        event: "cta_click",
        article_id: props.articleId,
        button_text: props.buttonText,
        destination_path: props.route,
      });
      // デバッグ用ログ（開発環境のみ）
      if (process.env.NODE_ENV === "development") {
        console.log("✅ dataLayer event pushed (GTM経由でGoogle Analyticsに送信されます):", {
          event: "cta_click",
          article_id: props.articleId,
          button_text: props.buttonText,
          destination_path: props.route,
        });
      }
    } catch (error) {
      console.error("❌ Failed to push to dataLayer:", error);
    }
  } else {
    console.error("❌ window.dataLayer is not available");
  }

  // articleIdが未設定の場合の警告（開発環境のみ）
  if (process.env.NODE_ENV === "development" && !hasArticleId) {
    console.warn("⚠️ articleId prop is missing");
  }

  router.push(props.route);
}
</script>

<style scoped>
.cta-sectionnaka {
  /* padding-bottom: 40px; */
  margin-left: 20px;
  margin-right: 20px;
}

.cta-button {
  background: #da3990;
  color: white !important;
  font-size: 16px;
  font-weight: bold;
  height: 60px;
  border: 3px solid #982da6;
  border-radius: 30px;
  position: relative;
  overflow: hidden;
}

.cta-button::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
  animation: shine 3s infinite;
}

.cta-button::after {
  content: "";
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.3) 0%, transparent 70%);
  animation: rotate 4s linear infinite;
}

@keyframes shine {
  0% {
    left: -100%;
  }
  50%,
  100% {
    left: 100%;
  }
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.bold-text {
  font-weight: bold;
}

.cta-sectionnaka-text {
  color: #333;
  margin: 0;
  line-height: 1.6;
  text-align: center;
  font-size: 16px;
  margin-bottom: 20px;
}

@media (min-width: 750px) {
  .cta-sectionnaka {
    margin-left: 30%;
    margin-right: 30%;
  }
}
</style>
